import {
  LpHero,
  Modal,
  If,
  WhatsAppButton,
  WhatsAppModalContent
} from '@itau-loans-www/components'
import { LandingPage } from '@itau-loans-www/templates'

import Accession from './components/Accession'
import Benefits from './components/Benefits'
import FgtsSliderSection from './components/FgtsSliderSection'
import Simulation from './components/Simulation'
import WhatsAppSection from './components/WhatsAppSection'
import { hero, faqs, antecipation, modalContent, slider } from './content'
import useFGTSLp from './hooks'

const FGTS = ({ partnerName }) => {
  const {
    lpText,
    canonical,
    isAdsSourceURL,
    heroCustomClass,
    setOpenWppModal,
    isToShowModal
  } = useFGTSLp(partnerName)

  return (
    <LandingPage
      faqContent={faqs}
      canonical={canonical}
      legalTextContent={lpText}
      partnerName={partnerName}
    >
      <div>
        <LpHero
          customClass={heroCustomClass}
          partnerName={partnerName}
          content={hero}
          productCode="fgts"
        />
      </div>
      <Simulation content={antecipation} showHelperText={false} />
      <If
        condition={!partnerName}
        renderIf={
          <>
            <If
              condition={!isAdsSourceURL}
              renderIf={
                <>
                  <WhatsAppButton />
                  <WhatsAppSection />
                </>
              }
            />

            <Modal
              type="pop"
              show={isToShowModal}
              onCloseClick={() => setOpenWppModal(false)}
            >
              <WhatsAppModalContent content={modalContent} />
            </Modal>
          </>
        }
        renderElse={<div />}
      />
      <FgtsSliderSection content={slider} />
      <Benefits />
      <Accession />
    </LandingPage>
  )
}

export default FGTS
